/**
 * Lista de indicadores ambientales
 */
import {
  DICCIONARIO_REGIONES_TEXTO_A_CODIGO,
  DICCIONARIO_REGIONES_CODIGO_A_TEXTO
} from "../data/ubigeo.data";
const Ubigeo = {
  getCodigoRegion: function(nombreRegion) {
    const diccionario = DICCIONARIO_REGIONES_TEXTO_A_CODIGO;
    nombreRegion = nombreRegion.toUpperCase();
    return diccionario[nombreRegion] ? diccionario[nombreRegion] : false;
  },
  getNombreRegion: function(codigoRegion) {
    const diccionario = DICCIONARIO_REGIONES_CODIGO_A_TEXTO;
    return diccionario[codigoRegion] ? diccionario[codigoRegion] : false;
  },
  getNombreRegionForUrl: function(codigoRegion) {
    const nombre = this.getNombreRegion(codigoRegion);
    return nombre ? nombre.toLowerCase().replace(/ /g, "_") : "";
  },
  getObjectRegion: function(codigoRegion) {
    const label = this.getNombreRegion(codigoRegion);
    if (label) {
      return { value: codigoRegion, label };
    }
    return null;
  }
};
export default Ubigeo;
